import { toTenantUrl } from '@shared/utils';

declare const NG_CONFIG: { [key: string]: any } | undefined;

// BUILD SPECIFIC ENVIRONMENTS, DURING DEPLOYMENT IT GETS DATA FROM APPROPRIATE ENV.JS FILE
export const environment = {
  production: true,
  envName: null,
  AUTH0_CLIENT_ID: null,
  AUTH0_DOMAIN: null,
  AUTH0_AUDIENCE: null,
  DEFAULT_DEV_TENANT: null,
  ...(typeof NG_CONFIG === 'undefined' ? {} : NG_CONFIG),
  API_BASE_URL: toTenantUrl(NG_CONFIG.API_BASE_URL),
  AUTH0_LOGOUT_URL: toTenantUrl(NG_CONFIG.AUTH0_LOGOUT_URL),
  AUTH0_REDIRECT_UI: toTenantUrl(NG_CONFIG.AUTH0_REDIRECT_UI),
  MOJO_JOB_UI_URL: toTenantUrl(NG_CONFIG.MOJO_JOB_UI_URL),
};
